import {inject, Injectable} from '@angular/core'
import {Title} from '@angular/platform-browser'

@Injectable()
export class TitleService {

  private readonly titleService = inject(Title)

  public setTitle(title: string): void {
    this.titleService.setTitle(`Crypto ID | ${title}`)
  }
}
